module.exports = __webpack_public_path__ + "static/media/15-Bayswater.9d01db26.mp4";